sc-upsell-submit-button {
  position: relative;
  display: block;

  .wp-block-button__link {
    position: relative;
    text-decoration: none;

    span {
      sc-icon {
        padding-right: var(--sc-spacing-small);
      }
    }

    [data-text], sc-spinner {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .sc-block-button--sold-out,
  .sc-block-button--unavailable {
    display: none !important;
  }

  &.is-unavailable {
    .sc-block-button__link {
      display: none !important;
    }
    .sc-block-button--unavailable {
      display: initial !important;
    }
  }

  &.is-sold-out {
    .sc-block-button__link {
      display: none !important;
    }
    .sc-block-button--sold-out {
      display: initial !important;
    }
  }

  sc-spinner::part(base) {
    --indicator-color: currentColor;
    --spinner-size: 12px;
    position: absolute;
    top: calc(50% - var(--spinner-size) + (var(--spinner-size) / 4));
    left: calc(50% - var(--spinner-size) + (var(--spinner-size) / 4));
  }

  [data-text],
  [data-loader] {
    transition: opacity var(--sc-transition-fast) ease-in-out, visibility var(--sc-transition-fast) ease-in-out;
  }

  [data-loader] {
    opacity: 0;
    visibility: hidden;
  }

  &.is-disabled {
    pointer-events: none;
  }

  &.is-busy {
    [data-text] {
      opacity: 0;
      visibility: hidden;
    }
    [data-loader] {
      opacity: 1;
      visibility: visible;
    }
  }

  &.is-out-of-stock {
    [data-text] {
      opacity: 0.6;
    }
  }
}
